var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2125_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1893 37C19.6893 37 37.1893 19 37.1893 17C37.1893 19 54.6893 37 57.1893 37C54.6893 37 37.1893 55 37.1893 57C37.1893 55 19.6893 37 17.1893 37Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2125_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.471 145.739V136H133.647L119.059 162.435C119.529 161.739 121.882 159.652 124.235 159.652C133.647 159.652 136 168 136 178.435C136 192.348 132.235 200 122.824 200C113.412 200 112 188.87 112 188.87",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2125_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2 135.027C96.2065 136.121 96.2065 136.121 96.2131 137.237C96.2546 144.111 96.3012 150.984 96.3533 157.858C96.38 161.392 96.4047 164.925 96.425 168.459C96.4447 171.87 96.4694 175.28 96.4976 178.691C96.5075 179.992 96.5156 181.293 96.5218 182.594C96.5308 184.416 96.5463 186.239 96.5633 188.062C96.5704 189.099 96.5775 190.136 96.5848 191.205C96.7299 193.806 96.9058 195.309 97.8 197.434C99.4224 198.586 99.4224 198.586 101 199.217C101 199.805 101 200.394 101 201C95.896 201 90.792 201 85.5333 201C85.5333 200.412 85.5333 199.823 85.5333 199.217C87.9093 198.334 87.9093 198.334 90.3333 197.434C90.358 190.854 90.377 184.275 90.3886 177.695C90.3942 174.64 90.4017 171.585 90.4138 168.53C90.4276 165.018 90.4328 161.506 90.4375 157.994C90.443 156.896 90.4485 155.799 90.4542 154.668C90.4543 153.142 90.4543 153.142 90.4544 151.585C90.4568 150.688 90.4592 149.792 90.4616 148.868C90.428 146.397 90.428 146.397 89.2667 143.942C88.0347 144.236 86.8027 144.531 85.5333 144.834C85.3573 143.951 85.1813 143.068 85 142.159C86.3635 140.959 87.7303 139.773 89.1 138.593C89.4847 138.253 89.8693 137.913 90.2656 137.562C90.642 137.24 91.0184 136.919 91.4063 136.587C91.7498 136.288 92.0933 135.989 92.4473 135.682C93.7473 134.898 94.8272 134.982 96.2 135.027Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2125_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.189 299C168.689 299 186.189 281 186.189 279C186.189 281 203.689 299 206.189 299C203.689 299 186.189 317 186.189 319C186.189 317 168.689 299 166.189 299Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2125_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2125_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 72,
    fill: "white",
    transform: "matrix(-1 0 0 -1 140 204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2125_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 70,
    fill: "white",
    transform: "matrix(-1 0 0 -1 103 203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2125_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(166 279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13D);
export default __webpack_public_path__ + "static/media/13D.34c3db3f06b0bed30a062fafbcc455b3.svg";
export { ForwardRef as ReactComponent };